/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { Suspense } from "react";
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter,
  HashRouter,
} from "react-router-dom";

import ScrollToTop from "./ScrollToTop";

import { lazyWithRetry } from "./ComponentLoader";
import { RouteWithSidebar } from "@vlinder-web/route-with-sidebar-widget-react";
import { VApplication } from "../application";
import { AppNavigatorService } from "../services";
import { useSMAppNavigator } from "./machines/pageContent";

//NOTE: Don't do lazy binding for landing page from v2 widget
import LandingPage from "../pages/Landing";

//Pages

//Privacy and Terms Pages

const TermsPage = lazyWithRetry(() => import("../pages/Terms"));
const PrivacyPage = lazyWithRetry(() => import("../pages/Privacy"));

//ErrorPages
const NotFoundPage = lazyWithRetry(() => import("../pages/Notfound"));
const ServerErrorPage = lazyWithRetry(() => import("../pages/ServerError"));

//Full Provenance Page
const FullProvenancePage = lazyWithRetry(
  () => import("../pages/FullProvenance")
);

//Product Detail Page
const ProductDetailPage = lazyWithRetry(
  () => import("../pages/ProductDetails")
);

//Provenance Step Detail Page
const ProvenanceDetailPage = lazyWithRetry(
  () => import("../pages/ProvenanceDetails")
);

//Camera capture
const TrinetraScannerPage = lazyWithRetry(
  () => import("../pages/TrinetraScanner")
);

//OCR preview
const TrinetraPreviewPage = lazyWithRetry(
  () => import("../pages/TrinetraPreview")
);

const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const RouterConfig = () => {
  const { appNavigatorSend, appNavigatorState, appNavigatorMachine } =
    useSMAppNavigator({});
  const appNavSrv = getAppNavService();

  const _handleDropDownItemClick = (item: any) => {
    console.log("on DD Item click =>", item);
  };

  if (appNavigatorState?.matches("RENDER_PAGE")) {
    const { routes } = { ...(appNavigatorState?.event?.data?.value || {}) };
    return (
      <Switch>
        <Route exact path="/" component={LandingPage} />

        <Route path={routes?.Product?.path} component={FullProvenancePage} />
        <Route
          path={routes?.ProductDetail?.path}
          component={ProductDetailPage}
        />
        <Route
          path={routes?.ProvenanceDetail?.path}
          component={ProvenanceDetailPage}
        />
        <Route
          path={routes?.TrinetraScanner?.path}
          component={TrinetraScannerPage}
        />
        <Route
          path={routes?.TrinetraPreview?.path}
          component={TrinetraPreviewPage}
        />
        <Route exact path={routes?.Privacy?.path} component={PrivacyPage} />
        <Route exact path={routes?.Terms?.path} component={TermsPage} />

        {/* <Route exact path={routes?.SignIn?.path} component={SignInPage} />
        <Route exact path={routes?.SignUp?.path} component={SignUpPage} />
       
        <Route
          exact
          path={routes?.ResetPassword?.path}
          component={ResetPasswordPage}
        />
        <Route
          exact
          path={routes?.ForgotPassword?.path}
          component={ForgotPasswordPage}
        />
        <Route exact path={routes?.Lock?.path} component={LockAccountPage} /> */}
        <Route
          exact
          path={routes?.ServerError?.path}
          component={ServerErrorPage}
        />
        <Route exact path={routes?.NotFound?.path} component={NotFoundPage} />

        <Redirect to={routes?.NotFound?.path} component={NotFoundPage} />
      </Switch>
    );
  }
  if (appNavigatorState?.matches("GET_PAGE_CONTENT")) {
    return <div>Loading...</div>;
  }
  return null;
};

export const AppNavigator = (): JSX.Element => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div />}>
        <RouterConfig />
      </Suspense>
    </BrowserRouter>
  );
};
